import React from "react"
// Styles
import * as styles from "./NavigationFooter.module.scss"

const NavigationFooter = (props) => {
    return <ul className={styles.NavigationFooter}>
        {props.navigation.map((page, index) => <li key={`footer-nav-${index}`}><a href={page.link}>{page.title}</a></li>)}
    </ul>

}

export default NavigationFooter